import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/Button'
import Input from 'components/Form/Input'
import classes from './EditUom.scss'

import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const EditUom = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Editing UOM
        <span className={classes['header-title--unimportant']}> – {props.uom.id}</span>
      </div>

      <div className={classes['header-buttons']}>
        <Button submit options={['green', 'small', 'desktop']}>
          Update
        </Button>

        <Button confirm options={['red', 'small']} callback={() => props.handleDelete(props.uom.id)}>
          Delete
        </Button>
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />
      <Input label='Shorthand' placeholder='shorthand' {...props.fields.shorthand} />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Update UOM
      </Button>
    </footer>
  </form>
)

EditUom.propTypes = {
  uom: PropTypes.object.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  handleDelete: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default EditUom



// WEBPACK FOOTER //
// ./src/components/Uoms/Edit/EditUom.js